module.exports = __webpack_public_path__ + "static/img/home_icon4.40c251e4.png";